// extracted by mini-css-extract-plugin
module.exports = {"loginFormContainer":"mNB5RRY6HMWNjyzAVragt","logo":"_1cMCfKKNzKBeSC6hDLkVml","information":"_2WmoQkuRnyfD1vDrIPYRCb","errorMsg":"JmB0wTm9mBaoFlcZkVQ_F"};